import {
  UseFormReturn as DefaultUseFormReturn,
  FieldValues,
  UseFormProps,
  useForm as useDefaultForm,
} from 'react-hook-form';

export const useForm = <FORM_TYPE extends FieldValues>(
  props: UseFormProps<FORM_TYPE> & {
    defaultValues: FORM_TYPE;
  }
): UseFormReturn<FORM_TYPE> => {
  return useDefaultForm(props);
};

export type UseFormReturn<FORM_TYPE extends FieldValues> = DefaultUseFormReturn<FORM_TYPE>;
